import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import WorkspaceNavbar from './WorkspaceNavbar';
import ConversationSidebar from './ConversationSidebar';
import ProjectGrid from './ProjectGrid';
import ChatPanel from './ChatPanel';
import PluginInstallModal from './PluginInstallModal';
import PricingDialog from './PricingDialog';
import CreateProjectDialog from './CreateProjectDialog';
import AccountSettingsSheet from './AccountSettingsSheet';
import AffiliatePanel from './AffiliatePanel';
import Walkthrough from './Walkthrough';
import { useSonas } from '../SonasContext';
import { toast } from 'sonner';

const AppWorkspace = ({ themeMode, setThemeMode }) => {
  const { 
    isStoreOpen, setIsStoreOpen,
    isSettingsOpen, setIsSettingsOpen,
    isCreateDialogOpen, setIsCreateDialogOpen,
    isAffiliateOpen, setIsAffiliateOpen,
    isWalkthroughOpen, completeWalkthrough, isProTutorial,
    createConversation
  } = useSonas();
  
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const location = useLocation();

  // Close mobile sidebar when navigating
  useEffect(() => {
    setMobileSidebarOpen(false);
  }, [location.pathname]);

  return (
    <div className="sonas-page flex flex-col h-screen overflow-hidden">
      <WorkspaceNavbar 
        onToggleMobileSidebar={() => setMobileSidebarOpen(!mobileSidebarOpen)} 
      />
      
      <div className="flex flex-1 overflow-hidden relative">
        <div className={`
          fixed inset-0 z-40 bg-black/60 backdrop-blur-sm transition-opacity md:hidden
          ${mobileSidebarOpen ? "opacity-100" : "opacity-0 pointer-events-none"}
        `} onClick={() => setMobileSidebarOpen(false)} />
        
        <div className={`
          fixed inset-y-0 left-0 z-50 transform transition-transform md:relative md:translate-x-0
          ${mobileSidebarOpen ? "translate-x-0" : "-translate-x-full"}
        `}>
          <ConversationSidebar />
        </div>
        
        <main className="flex-1 overflow-hidden flex flex-col relative">
          <Routes>
            <Route path="/" element={<ProjectGrid />} />
            <Route path="/chat/:projectId" element={<ChatPanel />} />
            <Route path="/chat" element={<ChatPanel />} />
            <Route path="*" element={<Navigate to="/app" replace />} />
          </Routes>
        </main>
      </div>

      <PluginInstallModal />
      <PricingDialog 
        open={isStoreOpen} 
        onOpenChange={setIsStoreOpen} 
        onPurchase={(id) => toast.info(`Purchase of ${id} initiated.`)} 
      />
      <CreateProjectDialog 
        open={isCreateDialogOpen} 
        onOpenChange={setIsCreateDialogOpen} 
        onCreate={(data) => createConversation(data?.name)} 
      />
      <AccountSettingsSheet 
        open={isSettingsOpen} 
        onOpenChange={setIsSettingsOpen} 
      />
      <AffiliatePanel
        open={isAffiliateOpen}
        onOpenChange={setIsAffiliateOpen}
      />
      
      <Walkthrough 
        open={isWalkthroughOpen} 
        onComplete={completeWalkthrough} 
        isProUpdate={isProTutorial}
      />
    </div>
  );
};

export default AppWorkspace;